import React, { useEffect, useState } from "react"
import { apiService } from "../../../api/axiosInstance"
import { InputText } from "primereact/inputtext"
import { Field, useFormikContext } from "formik"


import styles from "../../../styles/Form.module.css"

export default function MrfOrderName(props) {
  const [fetching, setFetching] = useState(true)

  const { fieldname, label, description, dataOrderId } = props

  const { setFieldValue } = useFormikContext()

  useEffect(() => {
    const fetchData = async () => {
      const response = await apiService.get(`/data-orders/${dataOrderId}/name`)
      if (response.data.status === "success") {
        const data_order_name = response.data.data.data_order_name || ""
        setFieldValue(fieldname, data_order_name)
        setFetching(false)
      }
    }
    fetchData()
  }, [dataOrderId])

  // TEMP: Display 'none'. Field not in use.
  return (
    <Field name={fieldname}>
      {({ field, meta }) => {
        return (
          <div className={styles.field} style={{ display: "none" }}>
            <label htmlFor={fieldname} className={styles.label}>
              {label}
            </label>
            {description && (
              <small style={{ display: "block", marginBottom: 10 }}>
                {description}
              </small>
            )}
            <InputText
              id={fieldname}
              value={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
            />
            {meta.touched && meta.error && (
              <div className={styles.error}>{meta.error}</div>
            )}
          </div>
        )
      }}
    </Field>
  )
}
